document.addEventListener("DOMContentLoaded", function() {
  const mainContent = document.getElementById("MainContent");
  const buttons = document.querySelectorAll('.combo-buttons button');
  const contentCache = {};

  buttons.forEach(button => {
    button.addEventListener('click', function(e) {
      // buttons.forEach(btn => btn.classList.remove('active'));
      var product_handle = this.getAttribute("cstm-datacart");
      fetchAndReplaceContent(product_handle, this);
    });
  });

  function fetchAndReplaceContent(url, button) {
    if (contentCache[url]) {
      updateContent(contentCache[url]);
      activateButton(button);
    } else {
      fetch(url)
        .then(response => {
          if (!response.ok) {
            throw new Error("Network response was not ok");
          }
          return response.text();
        })
        .then(html => {
          contentCache[url] = html;
          updateContent(html);
          prefetchAdjacentContent();
          activateButton(button);
        })
        .catch(error => {
          console.log("There was a problem fetching the content:", error);
        });
    }
  }

  function prefetchAdjacentContent() {
    const activeButton = document.querySelector('.combo-buttons button.active');
    if (activeButton) {
      const activeIndex = Array.from(buttons).indexOf(activeButton);
      const adjacentButtons = [buttons[activeIndex - 1], buttons[activeIndex + 1]].filter(Boolean);
      adjacentButtons.forEach(button => {
        const url = button.getAttribute('cstm-datacart');
        if (!contentCache[url]) {
          fetch(url)
            .then(response => response.text())
            .then(html => {
              contentCache[url] = html;
            })
            .catch(error => console.error("There was a problem prefetching content:", error));
        }
      });
    }
  }

  function updateContent(html) {
    const scrollPosition = window.scrollY;
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    const mainContentData = doc.getElementById('MainContent').innerHTML;
    mainContent.innerHTML = mainContentData;
    mainContent.classList.add('new-split-content'); 
    bindButtonEvents();
    includeExternalScripts();
    reinitializePlugins();
    window.scrollTo(0, scrollPosition);
  }


  function activateButton(button) {
      var product_handle = button.getAttribute('cstm-datacart');
      var currentURL = window.location.href;
   if (
    currentURL.includes('/metabolically-lean-weight-management-super-charged') ||
    currentURL.includes('/metabolically-lean-weight-management')
  ) {
    $('.cstmOptions').eq(0).trigger('click');
  } else {
    $('.cstmOptions').eq(2).trigger('click');
  }
    console.log("Current cstm-datacart value after content replacement: ", product_handle); 
    // buttons.forEach(btn => btn.classList.remove('active'));
    // button.classList.add('active');
    updateURL(button);
  }

  function updateURL(button) {
    var product_handle = button.getAttribute('cstm-datacart');
        var productHandleWithQuery = button.getAttribute('cstm-datacart');
    var productHandle = productHandleWithQuery.split('?')[0];
    console.log('vvvvvvvproduct_handle',product_handle);
    var baseUrl = window.location.href.split('/products/')[0];
    var newUrl = baseUrl + '/products/' + productHandle;
    window.history.replaceState(null, null, newUrl);
  var viewParam = product_handle.split('?view=')[1];
if (viewParam) {
  var newClass = 'template-product-' + viewParam;
  var existingClasses = document.body.className.split(' ');
  var classToRemove = existingClasses.find(cls => cls.startsWith('template-product-'));
  if (classToRemove) {
    document.body.classList.remove(classToRemove);
  }
  document.body.classList.add(newClass);
}
  }
  
  function reinitializePlugins() {
    $(".imageslider2").slick({
      infinite: true,
      arrows: false,
      autoplay: true,
      autoplaySpeed: 3000,
      dots: true,
      slidesToShow: 4,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            centerMode: true,
            centerPadding: '30px',
            slidesToScroll: 1
          }
        }
      ]
    });
        $(".imageslider").slick({
      infinite: true,
      arrows: false,
      autoplay: true,
      autoplaySpeed: 3000,
      dots: true,
      slidesToShow: 1,
      slidesToScroll: 1
    });
    $(".accordion-items").on("click", ".accordion-heading", function () {
      // $(this).toggleClass("active").next().slideToggle();
      $(".accordion-content").not($(this).next()).slideUp(300);
      $(this).siblings().removeClass("active");
    });
     const utmSource = window.utmSettings.utmParams;
  let add_cart = document.querySelector('.product-form__buttons.second-click .product-form__submit');
  let metafield_varinat = document.querySelectorAll('.varinat_show .variant-under');
  let pt_bt = document.querySelector('variant-radios').innerHTML;
  let All_varinat = document.querySelectorAll('.main-varinat'); 
  let Recommened_show = document.querySelectorAll(".Recommened_show");
  const Elem = document.querySelector('[varibox="upasell_variant-3"]');
  let next_class = document.querySelectorAll('.Popup_variant_1[checked]');
  let checkActive = document.querySelectorAll('.Popup_variant.selected');  
    if(checkActive.length){
    checkActive.forEach((item)=>{
      let Varinatid = item.getAttribute('varibox');
      let activevarinat = document.querySelector(`.${Varinatid}.False.NOnextpop`)?.closest("section").querySelector('.corss-popup-button');
      activevarinat?.classList.add('combo-none');
      let Stickyactive = document.querySelector(`.${Varinatid}.False.NOnextpop`)?.closest("section").querySelector('.ts-sticky-addtocart .corss-popup-button');
      Stickyactive?.classList.add('combo-none');
       let activeReco = document.querySelector(`.${Varinatid}.False.nextpop`)?.closest("section").querySelector('.main-varinat');
      activeReco?.classList.add('combo-none');
      let activeRecoNext = document.querySelector(`.${Varinatid}.False.nextpop`)?.closest("section").querySelector('.Recommened_show');
      activeRecoNext?.classList.add('Show-Element');
    })
  }
  if(next_class.length){
    next_class.forEach((item)=>{
      var next_click = item.nextElementSibling;
       next_click.click();
    })
  } 
   var cut_btn = document.querySelectorAll('.new-combo-products .variant-cut');
   cut_btn.forEach((item)=>{
    item.addEventListener('click',()=>{
        document.querySelector('.variant-pop').style.display="none";
        document.querySelector('body').classList.remove('no-scroll');
        document.querySelector(".Recommened_show").classList.remove('Show-Element');
        let add_cart1 = document.querySelector('.new-combo-products .product-form__buttons .button--secondary.product-form__submit');
        add_cart1 && add_cart1.click();
    })
  })
//close  Second NO THANKS ON POPUP
  var cut_btn1 = document.querySelectorAll('.variant-cut');
  var popup_hide =document.querySelectorAll('.variant-pop');
  cut_btn1?.forEach((item)=>{
    item.addEventListener('click',()=>{
        let main = item.closest('.shopify-section').querySelector('.variant-pop');
        main.style.display="none";
        let Recommened_show1 = item.closest('.shopify-section')?.querySelector('.Recommened_show');
        Recommened_show1?.classList.remove('Show-Element');
        document.querySelector('body').classList.remove('no-scroll');
        let add_cart = document.querySelector('.product-form__buttons.second-click .product-form__submit');
        add_cart && add_cart.click();
        let add_cart1 = item.closest('section').querySelector('.product-form__buttons .product-form__submit.button--secondary');
        add_cart1 && add_cart1.click();
    })
  })

  let lastClickedElement = null;
  if (metafield_varinat.length) {
    metafield_varinat.forEach((metbtn) => {
      metbtn.addEventListener('click', () => {
        if (lastClickedElement && lastClickedElement !== metbtn) {
          lastClickedElement.classList.remove('meta-click');
        }
        metbtn.classList.add('meta-click');
        let varinat_getAtt = metbtn.closest('.last_varinat_show').querySelector('.last_varinat_show .variant_upgrade_btn');
        let varinat_Att =metbtn.getAttribute('att');
        varinat_getAtt.setAttribute("prd-id",varinat_Att );
        lastClickedElement = metbtn.classList.contains('meta-click') ? metbtn : null;
        document.querySelectorAll('.Show-message').forEach((message) => {
          message.classList.remove('Show-Element');
        });
        let sibling = metbtn.nextElementSibling;
        if (sibling && sibling.classList.contains('Show-message')) {
          sibling.classList.add('Show-Element');
        }
      });
    });
  }  
  let combo_metafield_varinat = document.querySelectorAll('.template-product-combo-product .varinat_show .variant-under');
  combo_metafield_varinat?.forEach((com_item)=>{
    com_item.addEventListener('click', () => {
      com_item.classList.add('meta-click');
       document.querySelector('.Show-message')?.classList.remove('Show-Element');
    });
  })  
    let Recom_pdp = document.querySelectorAll('.Recom_Add_btn');
if(Recom_pdp.length){
  Recom_pdp.forEach((Rec_btn)=>{
    Rec_btn.addEventListener('click',()=>{
      Rec_btn.classList.add('back-color');
      document.querySelector(".cross-banner").style.display="none";
      setTimeout(() => {
          Rec_btn.classList.remove('back-color');
      }, "1000");
      let Att = Rec_btn.getAttribute('prd-id');
      let data = [];
      data.push({
          'id':Att,
          'quantity':1,
        'properties': {
        'utm_source': utmSource
      }
      });
      let formData = {
          'items':data,
          sections:['cart-drawer',"cart-count-bubble"]
      };
      fetch('/cart/add.js',{
        method:'POST',
        headers:{
           Accept:'application/json',
          'Content-Type':'application/json'
        },
        body:JSON.stringify(formData)
      }).then((response)=>{
        return response.json();
      }).then((resp)=>{
      }).catch(error => {
        console.log("ERROR :",error);
      });
      setTimeout(()=>{
          add_cart.click();
          document.querySelector('body').classList.remove('no-scroll');
          document.querySelector('.variant-pop').style.display="none";
      },1000)  
    })
  })
}
let varti =  document.querySelectorAll('.product-form__input .Popup_variant') 
let meta_varint = document.querySelectorAll('.total_varinat')
let varti_len = varti.length;
let final = varti_len/2;
  document.body.addEventListener('click',(e)=>{
    let target = e.target;
    target = target?.closest('.Popup_variant')
    if(target){
      let varti_len = target.closest('variant-radios').querySelectorAll('.Popup_variant');
      let ATT = 'upasell_variant-3';
      let TargetAtt = target.getAttribute('varibox');
      let allActivevarinat = document.querySelectorAll('.corss-popup-button');
      if(allActivevarinat.length){
        allActivevarinat.forEach((activeitem)=>{
          activeitem.classList.remove('combo-none');
        })  
      }
      let Mainvarinat = document.querySelectorAll('.main-varinat');
      if(Mainvarinat.length){
        Mainvarinat.forEach((item)=>{
          item.classList.remove('combo-none');
        })
      }
      let showStricky = document.querySelectorAll('.ts-sticky-addtocart .corss-popup-button');
      if(showStricky.length){
        showStricky.forEach((item)=>{
          item.classList.remove('Fiber-product');
        })    
      }
      let activevarinat = document.querySelector(`.${TargetAtt}.False.NOnextpop`)?.closest("section").querySelector('.corss-popup-button');
     activevarinat?.classList.add('combo-none');
        let Stickyactive = document.querySelector(`.${TargetAtt}.False.NOnextpop`)?.closest("section").nextElementSibling;
        let stictbtn = Stickyactive?.querySelector('.corss-popup-button');
        stictbtn?.classList.add('combo-none');  
       let activeReco = document.querySelector(`.${TargetAtt}.False.nextpop`)?.closest("section").querySelector('.main-varinat');
      activeReco?.classList.add('combo-none');
      let activeRecoNext = document.querySelector(`.${TargetAtt}.False.nextpop`)?.closest("section").querySelector('.Recommened_show');
      activeRecoNext?.classList.add('Show-Element');
      if(ATT == TargetAtt){
         let main_popup = document.querySelector(`.${TargetAtt}.upsell_inner`)?.closest('.variant-pop');
         main_popup?.classList.add('Fiber-product');
      }else{
        let main_popup = document.querySelector(`.${TargetAtt}.upsell_inner`)?.closest('.variant-pop');
         main_popup?.classList.remove('Fiber-product');
      }
       let last_varint = Number(target?.getAttribute("ind"));
      if(varti_len.length == last_varint){
        document.querySelectorAll('.show-product')?.forEach((p) => {
          p.style.display="block";
        });
         document.querySelectorAll('button.variant_upgrade_btn')?.forEach((b) => {
           b.style.display="none";
         });

        
      }else{
         document.querySelectorAll('.show-product')?.forEach((p) => {
           p.style.display="none";
         })
         document.querySelectorAll('button.variant_upgrade_btn')?.forEach((b) => {
           b.style.display="block";
         })

      }
      meta_varint.forEach((meta_btn)=>{
        meta_btn.style.display="none";
      })
      target.classList.remove('selected')
      let varinat_meta = target.getAttribute("varibox");
      const varinat_show = document.querySelectorAll(`.varinat_show .${varinat_meta}`)
      varinat_show.forEach(function(variant){
        variant.style.display = "flex";
      })
      let varinat_att = target.getAttribute("cstmvarint-id");
      document.querySelector('.product-form form.form input[name="id"]').value=varinat_att;
    }
  })
  let total_butn = document.querySelectorAll('.Open_pop');
let total_varinat = document.querySelectorAll('.cstmVariants .Popup_variant');
   
  let Select_btn = document.querySelector('.click_button .varinat_click');
  if(Select_btn){
    Select_btn.addEventListener('click', () => {
      var miniCart = document.querySelector("cart-drawer");
      let uytu = document.querySelector(`.varinat_show .variant-under.meta-click`);
      if(uytu){
      let attr = uytu.getAttribute('att');
      let data = [];
      data.push({
        'id':attr,
        'quantity':1,
        'properties': {
        'utm_source': utmSource
      }
      });
      let formData = {
        'items':data,
        sections: miniCart.getSectionsToRender().map((section) => section.id)
      };
      fetch('/cart/add.js',{
        method:'POST',
        headers:{
          Accept:'application/json',
          'Content-Type':'application/json'
        },
        body:JSON.stringify(formData)
      }).then((response)=>{
        return response.json();
      }).then((resp) => {
        miniCart.renderContents(resp);
        miniCart.classList.remove('is-empty')
        document.querySelector('.variant-pop').style.display="none";
        document.querySelector('body').classList.remove('no-scroll');
      }).catch(error => {
        console.log("ERROR :",error);
      });
      setTimeout(()=>{
        if(metafield_varinat){
             metafield_varinat.forEach((metremove)=>{
                metremove.classList.remove('meta-click');
             })
           }
      },2000);
      }
      else{
       document.querySelector('.Show-message').classList.add('Show-Element');
      }
    });
  }
  let cross_button = document.querySelectorAll('.cross-button');
  if(cross_button.length){
    let cross_remove1 = document.querySelectorAll('.Cross-sell-varinat');
    cross_button.forEach((cross_btn)=>{
      cross_btn.addEventListener('click',()=>{
        cross_button.forEach((cros_color)=>{
          cros_color.closest('.Cross-sell-varinat').classList.remove('back-color');
        })
        cross_btn.closest('.Cross-sell-varinat').classList.add('back-color');
        var miniCart = document.querySelector("cart-drawer");
        let Extra = document.querySelector('.total_varinat .variant-under.meta-click');
        let ATT = cross_btn.getAttribute('prd-id');
        let data = [];
         if(Extra){
            let ATT1 = Extra.getAttribute('att');
             data.push({
              'id':ATT1,
              'quantity':1,
               'properties': {
        'utm_source': utmSource
      }
              },
              {
                'id':ATT,
                'quantity':1,
                'properties': {
        'utm_source': utmSource
      }
              }
            );
        }else{
           data.push({
            'id':ATT,
            'quantity':1,
             'properties': {
        'utm_source': utmSource
      }
            });
        }
        
          let formData = {
            'items':data,
            sections: miniCart.getSectionsToRender().map((section) => section.id)
          };
           fetch('/cart/add.js',{
              method:'POST',
              headers:{
                Accept:'application/json',
                'Content-Type':'application/json'
              },
              body:JSON.stringify(formData)
            }).then((response)=>{
              return response.json();
            }).then((resp) => {
              miniCart.renderContents(resp);
              miniCart.classList.remove('is-empty')
              document.querySelector('.variant-pop').style.display="none";
              document.querySelector('body').classList.remove('no-scroll');
            }).catch(error => {
              console.log("ERROR :",error);
            });
          setTimeout(()=>{
            if(metafield_varinat){
             metafield_varinat.forEach((metremove)=>{
                metremove.classList.remove('meta-click');
             })
            }
            if(cross_remove1){
              cross_remove1.forEach((crossbtn)=>{
                crossbtn.classList.remove('back-color');
             })
            }
          },2000);
        })  
      })  
  }
  
  //Open First No Thanks button
  let next_pop = document.querySelectorAll('.POP-open');
  // let Recommened_show = document.querySelectorAll(".Recommened_show");
  let show_product =  document.querySelectorAll('.show-product');
 // if(next_pop){
    next_pop?.forEach((next_pop1)=>{
      
    next_pop1.addEventListener('click',()=>{
      Recommened_show?.forEach((Recommened)=>{
        Recommened.classList.add('Show-Element');
      })
      show_product.forEach((show)=>{
        show.style.display="none";
      })
      All_varinat.forEach((All)=>{
        All.style.display="none";
      })
      setTimeout(()=>{
        if(metafield_varinat){
         metafield_varinat.forEach((metremove)=>{
            metremove.classList.remove('meta-click');
         })
        }     
      },2000);
    })
    })
 // }
 let Banner = document.querySelectorAll('.prodct-image-banner');
 if(Banner.length){
   Banner.forEach((Ban_btn)=>{
   Ban_btn.addEventListener('click',()=>{
       var miniCart = document.querySelector("cart-drawer");
       var outer_popup = Ban_btn.closest('section').querySelector('.variant-pop');
       var id1 = Ban_btn.getAttribute('prd-id');
       var DataSet = [];
       DataSet.push({
         'id':id1,
         'quantity':1,
         'properties': {
        'utm_source': utmSource
      }
       })
       var NewformData = {
        'items':DataSet,
        sections: miniCart.getSectionsToRender().map((section) => section.id )
      };
      fetch('/cart/add.js',{
      method:'POST',
      headers:{
        Accept:'application/json',
        'Content-Type':'application/json'
      },
      body:JSON.stringify(NewformData)
      }).then((response)=>{
        return response.json();
      }).then((resp) => {
        console.log('resp',resp);
         miniCart.renderContents(resp);
          miniCart?.classList.remove('is-empty');
       // document.querySelector('.variant-pop').style.display="none";
        outer_popup.style.display = "none";
        document.querySelector('body').classList.remove('no-scroll');
        if(metafield_varinat){
            metafield_varinat.forEach((metbtn)=>{
             metbtn.classList.remove('meta-click');
            })  
        }
      }).catch(error => {
        console.log("ERROR :",error);
      });
   })
   });
 }
  let banner_button1= document.querySelectorAll('.banner-product-add-to-cart');
    banner_button1.forEach((banner_button)=>{
      let popup_show_hide = banner_button.closest('.shopify-section').querySelector('.variant-pop');
      let  recommend_hide = banner_button.closest('.shopify-section').querySelector('.Recommened_show');
      let add_cart1 = banner_button.closest('.shopify-section').querySelector('.product-form__buttons .product-form__submit.button--secondary');
      banner_button.addEventListener('click',()=>{
         var miniCart = document.querySelector("cart-drawer");
         var id1 = banner_button.getAttribute('varinat-id');
         var DataSet = [];
         DataSet.push({
           'id':id1,
           'quantity':1,
           'properties': {
        'utm_source': utmSource
      }
         })
         var NewformData = {
            'items':DataSet,
            sections: miniCart.getSectionsToRender().map((section) => section.id)
          };
        fetch('/cart/add.js',{
          method:'POST',
          headers:{
            Accept:'application/json',
            'Content-Type':'application/json'
          },
          body:JSON.stringify(NewformData)
        }).then((response)=>{
            return response.json();
        }).then((resp) => {
            miniCart.renderContents(resp);
            miniCart?.classList.remove('is-empty')
            popup_show_hide.style.display="none";
            recommend_hide?.classList.remove('Show-Element');
            document.querySelector('body').classList.remove('no-scroll');
            add_cart1 && add_cart1.click();
        }).catch(error => {
          console.log("ERROR :",error);
        });
      })
    });
        let Recommened_show_now = document.querySelectorAll(".Recommened_show");
    const popinner1 = document.querySelectorAll('.variant-pop');  
    document.body.addEventListener('click',(e)=>{
    let Recommened_show_now = document.querySelectorAll(".Recommened_show");
    const popinner1 = document.querySelectorAll('.variant-pop');  
    var clickedElement = event.target;  
    if (clickedElement.classList.contains('variant-pop')){
        var popup_main_box = clickedElement.closest('section').querySelectorAll('.variant-pop');
        if(popup_main_box.length){
            popup_main_box.forEach((main_pop)=>{
              main_pop.style.display ="none";
            })
        }
        var stickybutton = document.querySelectorAll('.ts-sticky-addtocart');
        if(stickybutton.length){
          stickybutton.forEach((item)=>{
            item.classList.remove('showSticky');
            let next_Element = item.querySelector('.ts-variant-picker');
            next_Element.classList.add('show')
          })
        }
        document.querySelector('body').classList.remove('no-scroll');
        Recommened_show_now?.forEach((Recommened)=>{
          Recommened?.classList.remove('Show-Element');
        })
        
        var popup_inner = clickedElement.closest('section').querySelectorAll('.variant-pop-box');
        if(popup_inner.length){
            popup_inner.forEach((inneritem)=>{
              inneritem.addEventListener('click',(event)=>{
               event.stopPropagation();
            })
          })
        }
    } 
  })
  var buttons = document.querySelectorAll(".Open_pop");
  console.log("buttons", buttons)
  if(buttons.length) {
    buttons.forEach((btn) => {
      btn.addEventListener("click", function() {
        var clickedElement = this;
        var showpopupbox = clickedElement.closest('section').querySelector('.variant-pop.Show-mainpopup');
        if(showpopupbox){
          showpopupbox.style.display="block";
          showpopupbox.classList.add('flix')
        }
        $('.page-width').css({'z-index':'auto'});
        document.querySelector('body').classList.add('no-scroll');
        var selectedVariant = document.querySelector('.Popup_variant.selected');
        var Attrubute1 = clickedElement.closest('section').querySelectorAll('.Popup_variant.selected');
        var last_productshow1 = clickedElement?.closest('section').querySelector('.varinat_show');
        var additionalProduct = clickedElement.closest("section").querySelector(".varinat_show");
        var Addclass = clickedElement.closest("section").querySelector('.last_varinat_show');
        var hideAll = clickedElement?.closest('section').querySelectorAll('.total_varinat');
        var HideALLVarinat = clickedElement?.closest('section').querySelector('.varinat_show .variant_upgrade_btn');       
        var main_popup_div = clickedElement?.closest('section').querySelectorAll('.main-varinat');
        var main_popup_banner = clickedElement?.closest('section').querySelectorAll('.main-varinat.combo-none');         
        var Recommened_banner = clickedElement?.closest('section').querySelector('.Recommened_show');     
        var stickybutton = document.querySelectorAll('.ts-sticky-addtocart');
        if(stickybutton.length){
          stickybutton.forEach((item)=>{
            item.classList.add('showSticky');
            let next_Element = item.querySelector('.ts-variant-picker');
            next_Element.classList.remove('show')
          })
        } 
        if(main_popup_div.length){
            main_popup_div.forEach((main_pop)=>{
              main_pop.style.display ="block";
            })
        }
         if(main_popup_banner.length>=1){
               if(Recommened_banner){
                 Recommened_banner.classList.add('Show-Element');
               }
            }
        if(Attrubute1.length){
          Attrubute1?.forEach((GetAttru)=>{
            let GETATT = GetAttru.getAttribute('varibox');
            hideAll?.forEach((hidevarinat)=>{
               hidevarinat.style.display="none";
            })
            document.querySelectorAll(`.${GETATT}`).forEach(item => {
              item.style.display="flex";
            })
             let sectec_varinat = document.querySelectorAll(`.${GETATT} .variant-under`);
            sectec_varinat[0].click();
          
          }) 
        }
        if(selectedVariant?.classList.contains("cstmOptions_last")) {
          if(additionalProduct) {
            var productToShow = additionalProduct.querySelector(".show-product");
            if(productToShow) {
              productToShow.style.display = "block";
            }
            if(Addclass) Addclass.classList.add('lastvarinatshow');
            if(last_productshow1)last_productshow1?.classList.add('lastnext');
          }
        } else {
          if(additionalProduct) {
            var productToShow = additionalProduct.querySelector(".show-product");
            if(productToShow) productToShow.style.display = "none";
            if(Addclass) Addclass.classList.remove('lastvarinatshow');
             if(last_productshow1)last_productshow1?.classList.remove('lastnext');
            if(HideALLVarinat){
             
                HideALLVarinat.style.display="block";
              
            }
           
          }
        }
      })
    })
  }
   document.querySelectorAll('.accordion-header').forEach(header => {
      header.addEventListener('click', () => {
        const content = header.nextElementSibling;
        const plusIcon = header.querySelector('.plus-icon');
        const minusIcon = header.querySelector('.minus-icon');

        const isOpen = content.style.display === "block";
        content.style.display = isOpen ? "none" : "block";
        plusIcon.style.display = isOpen ? "block" : "none";
        minusIcon.style.display = isOpen ? "none" : "block";
      });
    });
  const comboButtons = document.querySelectorAll('.template-product-metabolicallyeanswitch .combo-buttons');
  if (comboButtons.length > 1) {
    comboButtons[0].style.setProperty('display', 'none', 'important');
  }
    const gliderElem = document.querySelector('.mbswitch-doctor-choice .glider');
  if (!gliderElem) return;
  const glider = new Glider(gliderElem, {
    slidesToShow: 1,
    slidesToScroll: 1,
    draggable: true,
    arrows: {
      prev: '.glider-prev-new2',
      next: '.glider-next-new2'
    },
    responsive: [
      {
        breakpoint: 768,
        settings: { slidesToShow: 1 }
      },
      {
        breakpoint: 480,
        settings: { slidesToShow: 1 }
      }
    ]
  });
   const gliderElements = document.querySelectorAll('.mbswitch-doctor-choice .glider');
  gliderElements.forEach(gliderElem => {
    if (gliderElem.classList.contains('glider-initialized')) return;

    new Glider(gliderElem, {
      slidesToShow: 1,
      slidesToScroll: 1,
      draggable: true,
      arrows: {
        prev: gliderElem.closest('.glider-contain').querySelector('.glider-prev-new'),
        next: gliderElem.closest('.glider-contain').querySelector('.glider-next-new')
      },
      responsive: [
        { breakpoint: 768, settings: { slidesToShow: 1 } },
        { breakpoint: 480, settings: { slidesToShow: 1 } }
      ]
    });
  });

       $(document).on('click', '.cstmOptions', function() {
   const elements = document.querySelectorAll('[data-variant-show]');
    var cstmvrID = $(this).attr('cstmvarint-id');
    console.log("Custom Variant ID:", cstmvrID);
    elements.forEach(element => {
        element.classList.remove('additional-net-qty-active');
    });
    elements.forEach(element => {
        const dataVariantShow = element.getAttribute('data-variant-show');
        if (dataVariantShow === cstmvrID) {
            element.classList.add('additional-net-qty-active');
        }
    });
});
  document.querySelectorAll('.accordion-headerq').forEach(button => {
    button.addEventListener('click', () => {
      const item = button.parentElement;
      const isOpen = item.classList.contains('open');
      document.querySelectorAll('.accordion-item-mbswitch').forEach(i => i.classList.remove('open'));
      document.querySelectorAll('.accordion-icon').forEach(icon => icon.textContent = '+');
      if (!isOpen) {
        item.classList.add('open');
        button.querySelector('.accordion-icon').textContent = '−';
      }
    });
  });
    // window.renderQuinnWidgets();
    window.renderTazohCollectionBlocks();
    window.judgeme.visibleRevWidget();
!function(e){window.jdgm=window.jdgm||{},jdgm.CDN_HOST="https://cdn.judge.me/",
jdgm.docReady=function(d){(e.attachEvent?"complete"===e.readyState:"loading"!==e.readyState)?
setTimeout(d,0):e.addEventListener("DOMContentLoaded",d)},jdgm.loadCSS=function(d,t,o,s){
!o&&jdgm.loadCSS.requestedUrls.indexOf(d)>=0||(jdgm.loadCSS.requestedUrls.push(d),
(s=e.createElement("link")).rel="stylesheet",s.class="jdgm-stylesheet",s.media="nope!",
s.href=d,s.onload=function(){this.media="all",t&&setTimeout(t)},e.body.appendChild(s))},
jdgm.loadCSS.requestedUrls=[],jdgm.loadJS=function(e,d){var t=new XMLHttpRequest;
t.onreadystatechange=function(){4===t.readyState&&(Function(t.response)(),d&&d(t.response))},
t.open("GET",e),t.send()},jdgm.docReady((function(){(window.jdgmLoadCSS||e.querySelectorAll(
".jdgm-widget, .jdgm-all-reviews-page").length>0)&&(jdgmSettings.widget_load_with_code_splitting?
parseFloat(jdgmSettings.widget_version)>=3?jdgm.loadCSS(jdgm.CDN_HOST+"widget_v3/base.css"):
jdgm.loadCSS(jdgm.CDN_HOST+"widget/base.css"):jdgm.loadCSS(jdgm.CDN_HOST+"shopify_v2.css"),
jdgm.loadJS(jdgm.CDN_HOST+"loader.js"))}))}(document);
 var acc = document.getElementsByClassName("accordionn-additonalinfo");
var i;

for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function() {
    this.classList.toggle("active");
    var paneladditionalinfo = this.nextElementSibling;
    if (paneladditionalinfo.style.maxHeight) {
      paneladditionalinfo.style.maxHeight = null;
    } else {
      paneladditionalinfo.style.maxHeight = paneladditionalinfo.scrollHeight + "px";
    }
  });
}   
   document.querySelectorAll('.copy-img').forEach((img, index) => {
        img.addEventListener('click', function() {
            var codeElement = document.querySelectorAll('.code-to-copy')[index];
            var tempTextarea = document.createElement('textarea');
            tempTextarea.value = codeElement.textContent;
            document.body.appendChild(tempTextarea);
            tempTextarea.select();
            tempTextarea.setSelectionRange(0, 99999);
            document.execCommand('copy');
            document.body.removeChild(tempTextarea);
            var messageElement = document.querySelectorAll('.copy-message')[index];
            messageElement.style.display = 'block';
            setTimeout(function() {
                messageElement.style.display = 'none';
            }, 1000);
        });
    });    
  $(" .accordion-items").on("click", ".accordion-heading", function () {
  		$(this).toggleClass("active").next().slideToggle();
  		$(".accordion-content").not($(this).next()).slideUp(300);
  		$(this).siblings().removeClass("active");
  	});  
    const callUsExpertNumbers = document.querySelectorAll(".callusexpert-number");
const typeFromXSpeakToExperts = document.querySelectorAll(
  ".typefromx-speaktoexpert"
);
const liveElements = document.querySelectorAll(".start-slow-body");

function toggleVisibility() {
  const now = new Date();
  const currentHour = now.getHours();
  const currentMinute = now.getMinutes();
  const startHour = 10;
  const startMinute = 00;
  const endHour = 18;
  const endMinute = 30;

  const isWithinTime =
    (currentHour > startHour ||
      (currentHour === startHour && currentMinute >= startMinute)) &&
    (currentHour < endHour ||
      (currentHour === endHour && currentMinute <= endMinute));

  if (callUsExpertNumbers.length > 0) {
    callUsExpertNumbers.forEach((element) => {
      element.classList.toggle("active", isWithinTime);
    });
  }

  if (typeFromXSpeakToExperts.length > 0) {
    typeFromXSpeakToExperts.forEach((element) => {
      element.classList.toggle("active", !isWithinTime);
    });
  }

  if (liveElements.length > 0) {
    liveElements.forEach((element) => {
      element.classList.toggle("active", isWithinTime);
    });
  }
}

toggleVisibility();
setInterval(toggleVisibility, 60000);
  }

  function bindButtonEvents() {
    const buttons = document.querySelectorAll('.combo-buttons button');
    buttons.forEach(button => {
      button.addEventListener('click', function(e) {
        var product_handle = this.getAttribute("cstm-datacart");
        fetchAndReplaceContent(product_handle, this);
        // buttons.forEach(btn => btn.classList.remove('active'));
        // this.classList.add('active');
      });
    });
  }



function includeExternalScripts() {
    const scripts = [
      "//embed.typeform.com/next/embed.js",
    ];

    scripts.forEach((src) => {
      const script = document.createElement("script");
      script.src = src;
      script.async = false; 
      document.body.appendChild(script);
    });
  }
  
  prefetchAdjacentContent();
});
